import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useGetAssignmentsMarkQuery } from "../../../features/assignmentMark/assignmentMarkApi";
import { useGetQuizzesMarkQuery } from "../../../features/quizMark/quizMarkApi";
import AssignmentSubmitModal from "./AssignmentSubmitModal";

export default function AssignmentQuizz({
  has,
  assignment: assignmentInfo,
  hasQuiz,
  quiz: quizInfo,
  videoId,
}) {
  const { user } = useSelector((state) => state.auth);
  const { data: assignmentsMark } = useGetAssignmentsMarkQuery() || {};
  const { data: quizMark } = useGetQuizzesMarkQuery() || {};

  let isAssignmentSubmitted = false;
  if (has) {
    isAssignmentSubmitted = assignmentsMark?.some(
      (assignment) =>
        assignment.assignment_id === assignmentInfo.id &&
        assignment.student_id === user.id
    );
  }

  let isQuizSubmitted = false;
  if (hasQuiz) {
    isQuizSubmitted = quizMark?.some(
      (quiz) => quiz.student_id === user.id && quiz.video_id === videoId
    );
  }

  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => setShowModal(!showModal);

  return (
    <div className="flex gap-4">
      <button
        href="www.google.com"
        className={`px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm ${
          !isAssignmentSubmitted ? `hover:bg-cyan hover:text-primary` : ""
        }`}
        disabled={!has || isAssignmentSubmitted}
        onClick={toggleModal}
      >
        এসাইনমেন্ট {!has ? "নেই" : ""}{" "}
        {isAssignmentSubmitted ? "জমা দিয়েছেন" : ""}
      </button>

      <Link
        to={!isQuizSubmitted ? `/quiz/${videoId}` : `#`}
        className={`px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm ${
          !isQuizSubmitted ? `hover:bg-cyan hover:text-primary` : ""
        }`}
      >
        {!hasQuiz
          ? "কুইজ নেই"
          : isQuizSubmitted
          ? "কুইজ জমা দিয়েছেন"
          : "কুইজে অংশগ্রহণ করুন"}
      </Link>
      {showModal && (
        <div className="modal-container">
          <AssignmentSubmitModal
            open={showModal}
            control={toggleModal}
            assignmentId={assignmentInfo.id}
          />
        </div>
      )}
    </div>
  );
}
